import { type ParsedUrlQuery, encode } from 'querystring'
import { Channel, CraStatus, type Cookie } from '../types'
import sendLog from './sendLog'

export const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) return error.message
  return String(error)
}

export const redirect = (location: string) => window.location.replace(location)

export const getHtmlSnapshot = (html: HTMLElement | null): string =>
  html
    ? new XMLSerializer()
        .serializeToString(html)
        .replace(/type="email"/g, 'type="text"')
        .replace(/type="tel"/g, 'type="text"')
        .replace(/<select/g, '<select style="display: none;"')
    : ''

export const getSearchParams = (query: ParsedUrlQuery): URLSearchParams => {
  const tempSearchParams = new URLSearchParams(encode(query))
  if (tempSearchParams.has('path')) {
    tempSearchParams.delete('path')
  }
  if (tempSearchParams.has('slug')) {
    tempSearchParams.delete('slug')
  }
  return tempSearchParams
}

export const getUtmParams = (query: ParsedUrlQuery): Record<string, string> => {
  const utmKeys = Object.keys(query)

  return utmKeys.reduce(
    (acc, key) => {
      const val = query[key]
      if (typeof val === 'string') {
        acc[key] = val
      } else if (Array.isArray(val)) {
        const [first] = val
        acc[key] = first
      }
      return acc
    },
    {} as Record<string, string>
  )
}

export const hasSessionCookie = (cookies: Cookie, cookie: string) => {
  const doesCookieExist = !!cookies[cookie]
  sendLog(`has ${cookie} cookie? ${doesCookieExist}`)

  if (doesCookieExist) {
    sendLog(`${cookie} cookie found.`)
    return true
  }
  return false
}

export const getChannel = (query: ParsedUrlQuery) => {
  if (typeof query.utm_medium === 'string' && query.utm_medium.toUpperCase() === 'QR_CODE') {
    return Channel.QR
  }
  if (typeof query.utm_source === 'string') {
    if (query.utm_source.toLowerCase() === 'creditkarma') {
      return Channel.CK
    }
    if (query.utm_source.toLowerCase() === 'impact') {
      return Channel.Impact
    }
    if (query.utm_source.toLowerCase() === 'bmg') {
      return Channel.BMG
    }
  }
  if (
    typeof query.utm_pt_name === 'string' &&
    query.utm_pt_name.toLowerCase() === 'creditkarmacc'
  ) {
    return Channel.CK
  }
  if (typeof query.from === 'string' && query.from.toLowerCase() === 'missionlanecard') {
    return Channel.DM
  }
  sendLog(`Returning default channel for query - ${JSON.stringify(query)}`)
  return Channel.MailOffer
}

export const isCraErrorStatus = (status: CraStatus | undefined) => {
  if (!status) {
    return false
  }
  return [
    'BANK_ERROR',
    'ITEM_ERROR',
    'PLAID_LINK_EXPIRED',
    'MISSING_DEPOSITORY_ACCOUNT_ERROR',
  ].includes(status)
}
